export const Props = () => ({
    // Размер SVG
    size: {
        type: Number,
        default: 16
    },

    // Цвет крестика
    color: {
        type: String,
        default: '#6B7280'
    },

    // Толщина линий крестика
    lineWidth: {
        type: Number,
        default: 1.3
    },
})
